<footer class="sticky-footer">
  <div class="container my-auto">
    <div class="text-center my-auto copyright"><span class="text-light">Copyright © FIPARCO Espace PRO Client {{currentYear}}</span></div>
  </div>
</footer>
